import { createAction } from '@reduxjs/toolkit';

const FETCHING_STUDENT_LIST = 'FETCHING_STUDENT_LIST';
const FETCHING_STUDENT_LIST_SUCCESS = 'FETCHING_STUDENT_LIST_SUCCESS';
const FETCHING_STUDENT_LIST_FAILURE = 'FETCHING_STUDENT_LIST_FAILURE';
const UPDATE_STUDENTS = 'UPDATE_STUDENTS';
const STUDENT_FETCHING_ENROLL_LIST = 'STUDENT_FETCHING_ENROLL_LIST';
const ENROLL_SINGLE_ITEM = 'ENROLL_SINGLE_ITEM';

export interface studentListSuccessPayload {
    id?: number | string;
    first_name: string;
    last_name: string;
    username: string;
    email: string;
    birth_date?: string;
    role_name: string;
    role_code: string;
    role: number;
    postal_code?: string;
    phone: string;
    identity_number?: string;
    bank_id?: string;
    bank_account_number?: string;
    bank_account_name?: string;
    is_active: 0 | 1;
    date_joined: string;
    genre?: string;
    code: string;
    wards?: any;
    address?: string;
    classes?: number;
    class_name?: string;
    school?: number;
    school_name?: string;
    school_ward?: string;
    avatar_url?: string;
    wards_code?: string;
    openedx_id?: string;
}

type studentsUpdateType = {
    username: string | null;
    course_id: string | null;
    status: string | null;
}

export type studentsEnrollmentUpdateType = {
    enrollments: studentsUpdateType[];
}

export const fetchingStudentList = createAction(FETCHING_STUDENT_LIST, (filters: any) => ({
    payload: filters,
}));

export const fetchingStudentListSuccess = createAction<
    studentListSuccessPayload[]
>(FETCHING_STUDENT_LIST_SUCCESS);

export const fetchingStudentListFailure = createAction(
    FETCHING_STUDENT_LIST_FAILURE,
);

export const updateStudents = createAction<any>(
    UPDATE_STUDENTS,
    (data: studentsEnrollmentUpdateType) => ({
        payload: { data: data },
    }),
);

export const fetchEnrollList = createAction(STUDENT_FETCHING_ENROLL_LIST, (course_id: string | null,
    usernames: string[] | null, status: string | null, page: number, page_size: number) => ({
        payload: { course_id, usernames, status, page, page_size }
    }));

export const enrollSingleItem = createAction<any>(ENROLL_SINGLE_ITEM, (data: studentsEnrollmentUpdateType) => ({
    payload: { data: data },
}));

